const siteUrl = "https://www.silvercross.in";
// const siteUrl = "http://localhost:3000";

const SitePages = [
  {
    pageName: "Home",
    pageUrl: `${siteUrl}/`,
  },
  {
    pageName: "About",
    pageUrl: `${siteUrl}/about`,
  },
  {
    pageName: "OFFERINGS",
    pageUrl: `${siteUrl}/offerings`,
    subPages: [
      {
        subPageName: "ALKALIZER",
        subPageUrl: `${siteUrl}/offerings/Alkalizer?id=1`,
        products: [
          {
            productName: "ALKASIL",
            productUrl: `${siteUrl}/Alkalizer/Alkasil`,
          },
        ],
      },
      {
        subPageName: "ANTI FUNGAL & ANTISEPTIC",
        subPageUrl: `${siteUrl}/offerings/Anti Fungal & Antiseptic?id=2`,
        products: [
          {
            productName: "FLUCROSS-150",
            productUrl: `${siteUrl}/Anti Fungal & Antiseptic/FLUCROSS-150`,
          },
          {
            productName: "Clobesil",
            productUrl: `${siteUrl}/Anti Fungal & Antiseptic/Clobesil`,
          },
          {
            productName: "Sildine_20",
            productUrl: `${siteUrl}/Anti Fungal & Antiseptic/Sildine_20`,
          },
          {
            productName: "Sildine_plus_10",
            productUrl: `${siteUrl}/Anti Fungal & Antiseptic/Sildine_plus_10`,
          },
          {
            productName: "MUPISIL",
            productUrl: `${siteUrl}/Anti Fungal & Antiseptic/MUPISIL`,
          },
          {
            productName: "ITRASIL_100",
            productUrl: `${siteUrl}/Anti Fungal & Antiseptic/ITRASIL_100`,
          },
          {
            productName: "SILSEPTIC",
            productUrl: `${siteUrl}/Anti Fungal & Antiseptic/SILSEPTIC`,
          },
          {
            productName: "LULICROSS_10",
            productUrl: `${siteUrl}/Anti Fungal & Antiseptic/LULICROSS_10`,
          },
          {
            productName: "LULICROSS_20",
            productUrl: `${siteUrl}/Anti Fungal & Antiseptic/LULICROSS_20`,
          },
          {
            productName: "ITROSIL",
            productUrl: `${siteUrl}/Anti Fungal & Antiseptic/ITROSIL`,
          },
          {
            productName: "Lulicross_Spray",
            productUrl: `${siteUrl}/Anti Fungal & Antiseptic/Lulicross_Spray`,
          },
          {
            productName: "Dermisil_5",
            productUrl: `${siteUrl}/Anti Fungal & Antiseptic/Dermisil_5`,
          },
          {
            productName: "ITRASIL",
            productUrl: `${siteUrl}/Anti Fungal & Antiseptic/ITRASIL`,
          },
          {
            productName: "Clotrisil",
            productUrl: `${siteUrl}/Anti Fungal & Antiseptic/Clotrisil`,
          },
          {
            productName: "Sildine_Solution",
            productUrl: `${siteUrl}/Anti Fungal & Antiseptic/Sildine_Solution`,
          },
        ],
      },
      {
        subPageName: "ANTI-INFECTIVES",
        subPageUrl: `${siteUrl}/offerings/Anti-Infectives?id=3`,
        products: [
          {
            productName: "SILVERMOX CV 625",
            productUrl: `${siteUrl}/Anti-Infectives/SILVERMOX_CV-625`,
          },
          {
            productName: "AZEECROSS 250",
            productUrl: `${siteUrl}/Anti-Infectives/AZEECROSS-250`,
          },
          {
            productName: "CEPOCROSS 200",
            productUrl: `${siteUrl}/Anti-Infectives/CEPOCROSS`,
          },
          {
            productName: "OFLOCROSS OZ",
            productUrl: `${siteUrl}/Anti-Infectives/OFLOCROSS-OZ`,
          },
          {
            productName: "SILVERMOX CV DRY SYRUP (GLASS)",
            productUrl: `${siteUrl}/Anti-Infectives/SILVERMOXCV228DS`,
          },
          {
            productName: "CEFASIL SB",
            productUrl: `${siteUrl}/Anti-Infectives/CEFASIL_SB`,
          },
          {
            productName: "CEPOCROSS 50 Oral Suspension",
            productUrl: `${siteUrl}/Anti-Infectives/CEPOCROSS_DS_50`,
          },
          {
            productName: "CEFASIL 100 Oral Suspension",
            productUrl: `${siteUrl}/Anti-Infectives/CEFASIL_DS_100`,
          },
          {
            productName: "CEPOCROSS 100 Oral Suspension",
            productUrl: `${siteUrl}/Anti-Infectives/CEPOCROSS_DS_100`,
          },
          {
            productName: "CEFASIL 50 Oral Suspension",
            productUrl: `${siteUrl}/Anti-Infectives/CEFASIL_DS_50`,
          },
          {
            productName: "OFLOCROSS M 30ML",
            productUrl: `${siteUrl}/Anti-Infectives/Oflocross_M_30`,
          },
          {
            productName: "CEFASIL 200",
            productUrl: `${siteUrl}/Anti-Infectives/cefasil_200`,
          },
          {
            productName: "Oflocross M 60ml",
            productUrl: `${siteUrl}/Anti-Infectives/Oflocross_M_60`,
          },
          {
            productName: "AZEECROSS 500",
            productUrl: `${siteUrl}/Anti-Infectives/Azeecross`,
          },
          {
            productName: "OFLOCROSS 200",
            productUrl: `${siteUrl}/Anti-Infectives/Oflocross_200`,
          },
          {
            productName: "CLEVOR 500",
            productUrl: `${siteUrl}/Anti-Infectives/Clevor_500`,
          },
        ],
      },
      {
        subPageName: "ANTIHISTAMINE",
        subPageUrl: `${siteUrl}/offerings/Antihistamine?id=4`,
        products: [
          {
            productName: "CETROS",
            productUrl: `${siteUrl}/Antihistamine/CETROS`,
          },
          {
            productName: "CETROS-L",
            productUrl: `${siteUrl}/Antihistamine/CETROS-L`,
          },
          {
            productName: "MONTECROSS LC",
            productUrl: `${siteUrl}/Antihistamine/MONTECROSS-LC`,
          },
          {
            productName: "CETROS Syrup",
            productUrl: `${siteUrl}/Antihistamine/CETROS_60`,
          },
          {
            productName: "MONTRECROSS-LC KID",
            productUrl: `${siteUrl}/Antihistamine/MONTECROSS_LC_kid`,
          },
          {
            productName: "CETROS-L 60ML",
            productUrl: `${siteUrl}/Antihistamine/CETROS_L_60`,
          },
          {
            productName: "MONTECROSS-LC KID",
            productUrl: `${siteUrl}/Antihistamine/MONTECROSS_LC_kid`,
          },
          {
            productName: "Montecross FX",
            productUrl: `${siteUrl}/Antihistamine/Montecross_FX`,
          },
          {
            productName: "Fexcro 120",
            productUrl: `${siteUrl}/Antihistamine/Fexcro_120`,
          },
          {
            productName: "Fexcro 180",
            productUrl: `${siteUrl}/Antihistamine/Fexcro_180`,
          },
        ],
      },
      {
        subPageName: "Cough & Cold",
        subPageUrl: `${siteUrl}/offerings/Cough & Cold?id=5`,
        products: [
          {productName: "COFCROSS-BR 100 ML", productUrl: `${siteUrl}/Cough & Cold/COFCROSS-BR`},
          {productName: "COFCROSS-Q", productUrl: `${siteUrl}/Cough & Cold/COFCROSS-Q`},
          {productName: "COLDCROSS", productUrl: `${siteUrl}/Cough & Cold/COLDCROSS`},
          {productName: "COFCROSS SYRUP 100ML", productUrl: `${siteUrl}/Cough & Cold/KOFCROS-D`},
          {productName: "CETROS COLD", productUrl: `${siteUrl}/Cough & Cold/CETROS-COLD`},
          {productName: "COFCROSS SOFTGELS", productUrl: `${siteUrl}/Cough & Cold/COFCROSS-SOFTGEL`},
          {productName: "ACECROSS", productUrl: `${siteUrl}/Cough & Cold/ACECROSS`},
          {productName: "Nimucross Cold and Flu", productUrl: `${siteUrl}/Cough & Cold/NIMUCROSS-CNF`},
          {productName: "COFCROSS-D JUNIOR", productUrl: `${siteUrl}/Cough & Cold/COFCROSS_60`},
          {productName: "COFCROSS 60ML", productUrl: `${siteUrl}/Cough & Cold/COFCROSS_SYRUP_60ML`},
          {productName: "COFCROSS-LS", productUrl: `${siteUrl}/Cough & Cold/COFCROSS_LS`},
          {productName: "Inhale In", productUrl: `${siteUrl}/Cough & Cold/BREATH_X`},
          {productName: "COFCROSS BR SYRUP 60ML", productUrl: `${siteUrl}/Cough & Cold/COFCROSS_BR_60`},
          {productName: "Cofcross DX 100ml", productUrl: `${siteUrl}/Cough & Cold/Cofcross_DX`},
          {productName: "SardiGo Drops", productUrl: `${siteUrl}/Cough & Cold/SardiGo`},
        ],
      },
      {
        subPageName: "Eye Drops",
        subPageUrl: `${siteUrl}/offerings/Eye Drops?id=6`,
        products: [
          {
            productName: "Moxisil D",
            productUrl: `${siteUrl}/Eye Drops/Moxisil_D`,
          },
          {
            productName: "Ciprosil-D",
            productUrl: `${siteUrl}/Eye Drops/Ciprosil_D`,
          },
        ],
      },
      {
        subPageName: "Gastro",
        subPageUrl: `${siteUrl}/offerings/Gastro?id=7`,
        products: [
          {productName: "PANTOCROSS-DSR", productUrl: `${siteUrl}/Gastro/PANTOCROSS-DSR`},
          {productName: "RABECROSS-DSR", productUrl: `${siteUrl}/Gastro/RABECROSS-DSR`},
          {productName: "OMESIL-D", productUrl: `${siteUrl}/Gastro/OMESIL-D`},
          {productName: "SPASMOCROSS", productUrl: `${siteUrl}/Gastro/SPASMOCROSS`},
          {productName: "SILCAINE GEL", productUrl: `${siteUrl}/Gastro/SILCAINE-GEL`},
          {productName: "PANTOCROSS-D", productUrl: `${siteUrl}/Gastro/PANTOCROSS-D`},
          {productName: "PANTOCROSS 40", productUrl: `${siteUrl}/Gastro/PANTOCROSS-40`},
          {productName: "OMESIL 20", productUrl: `${siteUrl}/Gastro/OMESIL`},
          {productName: "GELUCROSS", productUrl: `${siteUrl}/Gastro/GELUCROSS`},
          {productName: "SILTAC 150", productUrl: `${siteUrl}/Gastro/SILTAC_150`},
          {productName: "Silvercross (ORS)", productUrl: `${siteUrl}/Gastro/ORS`},
          {productName: "KREMACROS PLUS", productUrl: `${siteUrl}/Gastro/KREMACROS_PLUS`},
          {productName: "SUFASIL 200ML", productUrl: `${siteUrl}/Gastro/Sufasil`},
          {productName: "SUFASIL O 200ML", productUrl: `${siteUrl}/Gastro/Sufasil_O`},
          {productName: "VOMICROSS MD 4 TAB", productUrl: `${siteUrl}/Gastro/VOMI-ROK-MD-4`},
          {productName: "SILVER CROSS ORS", productUrl: `${siteUrl}/Gastro/ORS`},
          {productName: "Pantocross LS", productUrl: `${siteUrl}/Gastro/Pantocross_LS`},
          {productName: "Siltac D", productUrl: `${siteUrl}/Gastro/Siltac_D`},
        ],
      },
      {
        subPageName: "Liver Support",
        subPageUrl: `${siteUrl}/offerings/Liver Support?id=8`,
        products: [
          {productName: "Livocross Syrup", productUrl: `${siteUrl}/Liver Support/Livocross_syp`},
          {productName: "Ursosil 300", productUrl: `${siteUrl}/Liver Support/Ursosil_300`},
          {productName: "Ursosil 150", productUrl: `${siteUrl}/Liver Support/Ursosil_150`},
        ],
      },
      {
        subPageName: "OTC",
        subPageUrl: `${siteUrl}/offerings/OTC?id=9`,
        products: [
          {productName: "VILGORA 100", productUrl: `${siteUrl}/OTC/VILGORA_100`},
          {productName: "KETOCROSS Z Shampoo", productUrl: `${siteUrl}/OTC/KETOCROSS_PLUS`},
          {productName: "SILNASE NASAL SPRAY ADULT", productUrl: `${siteUrl}/OTC/Silnase_Adult`},
          {productName: "SILNASE NASAL SPRAY JUNIOR", productUrl: `${siteUrl}/OTC/Silnase_Junior`},
          {productName: "KETOCROSS CT SOAP", productUrl: `${siteUrl}/OTC/ketocross_CT`},
          {productName: "SILSHINE CREAM 20GM", productUrl: `${siteUrl}/OTC/SILSHINE`},
          {productName: "SILBIOTIC CAPS", productUrl: `${siteUrl}/OTC/Silbiotic`},
          {productName: "ORASIL", productUrl: `${siteUrl}/OTC/SIL-ORASURE`},
          {productName: "Clotrisil Powder", productUrl: `${siteUrl}/OTC/Clotrisil_powder`},
          {productName: "4Coal Facewash", productUrl: `${siteUrl}/OTC/4Coal`},
          {productName: "Erasil", productUrl: `${siteUrl}/OTC/Erasil`},
          {productName: "Silfresh", productUrl: `${siteUrl}/OTC/Silfresh_drops`},
        ],
      },
      {
        subPageName: "Pain Relief",
        subPageUrl: `${siteUrl}/offerings/Pain Relief?id=10`,
        products: [
          {productName: "MEFER-SPAS", productUrl: `${siteUrl}/Pain Relief/MEFER-SPAS`},
          {productName: "NIMUCROSS-P", productUrl: `${siteUrl}/Pain Relief/NIMUCROSS-P`},
          {productName: "SC22", productUrl: `${siteUrl}/Pain Relief/SC22`},
          {productName: "NIMUCROSS-PG", productUrl: `${siteUrl}/Pain Relief/NIMUCROSS-PG`},
          {productName: "NIMUCROSS", productUrl: `${siteUrl}/Pain Relief/NIMUCROSS`},
          {productName: "SILNAC-P", productUrl: `${siteUrl}/Pain Relief/SILNAC-P`},
          {productName: "SILNAC-MR", productUrl: `${siteUrl}/Pain Relief/SILNAC-MR`},
          {productName: "PARAKROS-650", productUrl: `${siteUrl}/Pain Relief/PARAKROS-650`},
          {productName: "PARAKROS-650", productUrl: `${siteUrl}/Pain Relief/PARAKROS-650`},
          {productName: "MEFCROSPAS", productUrl: `${siteUrl}/Pain Relief/MEFCROSPAS`},
          {productName: "MEFER-SPAS", productUrl: `${siteUrl}/Pain Relief/MEFER-SPAS`},
          {productName: "SILNAC-SP", productUrl: `${siteUrl}/Pain Relief/SILNAC-SP`},
          {productName: "PARACROSS_250", productUrl: `${siteUrl}/Pain Relief/PARACROSS_250`},
          {productName: "ACECROSS_SP", productUrl: `${siteUrl}/Pain Relief/ACECROSS_SP`},
          {productName: "PARAKROS 500", productUrl: `${siteUrl}/Pain Relief/PARAKROS 500`},
          {productName: "ACECROSS_SP", productUrl: `${siteUrl}/Pain Relief/ACECROSS_SP`},
          {productName: "PARAKROSS_250MG_60ML", productUrl: `${siteUrl}/Pain Relief/PARAKROSS_250MG_60ML`},
          {productName: "Etocross_120", productUrl: `${siteUrl}/Pain Relief/Etocross_120`},
          {productName: "Etocross_60", productUrl: `${siteUrl}/Pain Relief/Etocross_60`},
          {productName: "Etocross_90", productUrl: `${siteUrl}/Pain Relief/Etocross_90`},
          {productName: "Etocross_P", productUrl: `${siteUrl}/Pain Relief/Etocross_P`},
          {productName: "Predsil_16", productUrl: `${siteUrl}/Pain Relief/Predsil_16`},
          {productName: "Predsil_4", productUrl: `${siteUrl}/Pain Relief/Predsil_4`},
          {productName: "Predsil_8", productUrl: `${siteUrl}/Pain Relief/Predsil_8`},
          {productName: "SILGESIC-GEL", productUrl: `${siteUrl}/Pain Relief/SILGESIC-GEL`},
          {productName: "DP-CROSS", productUrl: `${siteUrl}/Pain Relief/DP-CROSS`},
          {productName: "Pregabil_75", productUrl: `${siteUrl}/Pain Relief/Pregabil_75`},
          {productName: "Pregabil_NT", productUrl: `${siteUrl}/Pain Relief/Pregabil_NT`},
          {productName: "Spredil", productUrl: `${siteUrl}/Pain Relief/Spredil`},
          {productName: "Spredil_16", productUrl: `${siteUrl}/Pain Relief/Spredil_16`},
          {productName: "Spredil_4", productUrl: `${siteUrl}/Pain Relief/Spredil_4`},
          {productName: "Spredil_8", productUrl: `${siteUrl}/Pain Relief/Spredil_8`},
          {productName: "DP_CROSS_MR", productUrl: `${siteUrl}/Pain Relief/DP_CROSS_MR`},
          {productName: "Mefcro_P_DS", productUrl: `${siteUrl}/Pain Relief/Mefcro_P_DS`},
        ],
      },
      {
        subPageName: "Supplements",
        subPageUrl: `${siteUrl}/offerings/Supplements?id=11`,
        products: [
          {productName: "CAL2SIL SG", productUrl: `${siteUrl}/Supplements/CAL2SIL SG`},
          {productName: "FEROCROSS XT", productUrl: `${siteUrl}/Supplements/FEROCROSS_XT`},
          {productName: "CAL2SIL K7", productUrl: `${siteUrl}/Supplements/CAL2SIL_K7`},
          {productName: "INCRESIL PLUS (PINEAPPLE)", productUrl: `${siteUrl}/Supplements/INCRESIL_PLUS`},
          {productName: "SILVITA - m", productUrl: `${siteUrl}/Supplements/VITA-MAN`},
          {productName: "CAL2SIL K27 PLUS", productUrl: `${siteUrl}/Supplements/CAL2SIL_K27_PLUS`},
          {productName: "SILVIT E", productUrl: `${siteUrl}/Supplements/SILVIT_E`},
          {productName: "INCRESIL", productUrl: `${siteUrl}/Supplements/INCRESIL`},
          {productName: "MECOSIL FORTE CAPSULE 10X1X10S", productUrl: `${siteUrl}/Supplements/MECOSIL-FORTE`},
          {productName: "VVITEE", productUrl: `${siteUrl}/Supplements/VVITEE`},
          {productName: "Silvit-M", productUrl: `${siteUrl}/Supplements/Silvit-M`},
          {productName: "SILVITA 5G", productUrl: `${siteUrl}/Supplements/Silvita-5G`},
          {productName: "FEROCROSS 450ml SYR", productUrl: `${siteUrl}/Supplements/Ferocross_450`},
          {productName: "B-COMSIL", productUrl: `${siteUrl}/Supplements/B_Comsil`},
          {productName: "FEROCROSS SYRUP-300ML", productUrl: `${siteUrl}/Supplements/Ferocross_300ml`},
          {productName: "SILVITA-7G", productUrl: `${siteUrl}/Supplements/Silvit_7G`},
          {productName: "Calsulin-K27", productUrl: `${siteUrl}/Supplements/Calsulin-K27`},
          {productName: "SILVITA-D3", productUrl: `${siteUrl}/Supplements/Silvita_D3`},
          {productName: "CALSULIN-K27 SG", productUrl: `${siteUrl}/Supplements/CALSULIN_K27`},
          {productName: "FEROCROSS 450ml SYRUP", productUrl: `${siteUrl}/Supplements/Ferocross_450`},
          {productName: "Fly-Cosil Syrup", productUrl: `${siteUrl}/Supplements/Flycosil`},
        ],
      },
      {
        subPageName: "Women",
        subPageUrl: `${siteUrl}/offerings/Women?id=13`,
        products: [{productName: "PRIMOCROSS N", productUrl: `${siteUrl}/Women/PRIMOCROSS_N`}],
      },
    ],
  },
  {
    pageName: "COMMUNITY",
    pageUrl: `${siteUrl}/community`,
  },
  {
    pageName: "CAREERS",
    pageUrl: `${siteUrl}/careers`,
  },
  {
    pageName: "CONTACT",
    pageUrl: `${siteUrl}/contact`,
  },
];

export default SitePages;
